import React from 'react';
import {
  Box,
  Typography,
  Pagination,
  MenuItem,
} from '@mui/material';
import Select from '../../UIKit/Select';
import { useTranslation } from 'react-i18next';

const UserPagination = ({
  pagination,
  onPageChange,
  onLimitChange,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 4,
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          {t('common:pagination.rows_per_page')}
        </Typography>
        <Select
          value={pagination.limit}
          onChange={onLimitChange}
          size="small"
          sx={{ minWidth: 80 }}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </Box>

      {pagination.pages > 1 && (
        <Pagination
          count={pagination.pages}
          page={pagination.page}
          onChange={onPageChange}
          color="primary"
          showFirstButton
          showLastButton
        />
      )}

      <Typography variant="body2" color="text.secondary">
        {t('common:pagination.showing_items', {
          from: Math.min(
            (pagination.page - 1) * pagination.limit + 1,
            pagination.total
          ),
          to: Math.min(
            pagination.page * pagination.limit,
            pagination.total
          ),
          total: pagination.total,
        })}
      </Typography>
    </Box>
  );
};

export default UserPagination; 